import { alpha, Theme } from '@mui/material';

export default {
    highlighted: {
        position: 'relative',
        '&::before': {
            content: '""',
            backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.08),
            position: 'absolute',
            height: '30px',
            right: '0',
            top: '0',
            zIndex: '-1',
        },
    },
};
